import axios from "axios";
import Session from "../helpers/SessionHelper";
import {
  GET_USER_FIELD_DETAILS,
  GET_USER_DETAILS,
  USERS,
  USERS_BUSINESS_FARMS,
  USERS_FARMS_TRANSFER,
  GRAPHS,
  VALIDATIONS,
  REGISTRATIONS,
  FIELDS,
  CLAIMS,
} from "../../src/configurations/Urls";

const UserService = {
  async validateUser(payload) {
    if (!payload) return;
    const response = await axios.post(VALIDATIONS, payload);
    return response;
  },

  async getUserDetails(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(GET_USER_DETAILS, payload, {
      headers: headers,
    });
    return response;
  },

  async getUserFieldDetails(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(GET_USER_FIELD_DETAILS, payload, {
      headers: headers,
    });
    return response;
  },

  async getUserFieldsWithNoCrops(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(`${FIELDS}/no-crops${payload}`, {
      headers: headers,
    });
    return response;
  },

  async getUserWaterData(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(USERS + payload, {
      headers: headers,
    });
    return response;
  },

  async getUserGraphData(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(GRAPHS + payload, {
      headers: headers,
    });
    return response;
  },
  async getUserRegisteredFields() {
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(REGISTRATIONS, {
      headers: headers,
    });
    return response;
  },
  async submitAddedFields(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(FIELDS, payload, {
      headers: headers,
    });
    return response;
  },

  async deleteRegisteredField(fieldId) {
    if (!fieldId) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios({
      method: "DELETE",
      url: `${FIELDS}/${fieldId}`,
      headers: headers,
    });
    return response;
  },

  async deleteClaimedField(claimId) {
    if (!claimId) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios({
      method: "DELETE",
      url: `${CLAIMS}/${claimId}`,
      headers: headers,
    });
    return response;
  },

  async updateRegisteredField(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.put(FIELDS, payload, {
      headers: headers,
    });
    return response;
  },

  async claimRegisteredField(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(CLAIMS, payload, {
      headers: headers,
    });
    return response;
  },

  async getProfileInfo() {
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(USERS + "/profile", {
      headers: headers,
    });
    return response;
  },

  async updateProfileInfo(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithTokenForMultipart();
    const response = await axios.put(USERS, payload, {
      headers: headers,
    });
    return response;
  },

  async addBusinessFarm(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(USERS_BUSINESS_FARMS, payload, {
      headers: headers,
    });
    return response;
  },

  async updateBusinessFarms(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.put(USERS_BUSINESS_FARMS, payload, {
      headers: headers,
    });
    return response;
  },

  async transferFarms(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.put(USERS_FARMS_TRANSFER, payload, {
      headers: headers,
    });
    return response;
  },
};
export default UserService;
